import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form } from 'redux-form';

import { handleAddressChange } from 'checkout/checkout/common/helpers';
import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError } from 'common/components/layout';
import { getDefaultCountryCode, removeSpaces } from 'common/helpers/miscHelper';
import {
  integerFormat,
  convertStringToInteger
} from 'common/helpers/numberHelper';
import { listCustomerAddresses } from 'redux/customerAddresses/actions';
import { listCustomerCreditCards } from 'redux/customerCreditCards/actions';
import { updateAndProcessReservationCart } from 'redux/reservationCart/actions';

import { requiresCreditCard } from '../helpers';

import AddressPicker from './components/AddressPicker';
import CreditCardLoggedIn from './components/CreditCardLoggedIn';
import {
  validateAddressForLoggedInCustomer,
  validateCreditCard
} from './validators';

class Payment extends Component {
  componentDidMount() {
    const { props } = this;
    props.listCustomerAddresses();
    props.listCustomerCreditCards();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form, props);
    const reservationCart = {
      creditCard: data.creditCard,
      billTo: data.address
    };
    const successFunction = (reservation) => {
      props.history.push(`/reservation/checkout/receipt/${reservation.id}`);
    };
    props.updateAndProcessReservationCart(reservationCart, successFunction);
  };

  handleAddressChange = (e) => {
    const { props } = this;
    const addressId = e.target.value;
    let address;
    if (addressId) {
      address = props.customerAddresses.data[addressId];
    }
    handleAddressChange(addressId, address, props.change, props.settings);
  };

  handleBack = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onEdit('customer');
  };

  render() {
    const { handleSubmit, change, form, settings } = this.props;
    const { customerAddresses, customerCreditCards } = this.props;
    const { selectedCreditCardId, reservationCart } = this.props;
    const object = { countryCode: getDefaultCountryCode(settings) };
    const showCreditCard = requiresCreditCard(reservationCart);
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        {showCreditCard && (
          <>
            <h3>Payment method</h3>
            <p>All transactions are secure and encrypted.</p>
            <CreditCardLoggedIn
              customerCreditCards={customerCreditCards}
              selectedCreditCardId={selectedCreditCardId}
              handleSaveCreditCard={this.handleSaveCreditCard}
            />

            <p>&nbsp;</p>
          </>
        )}
        <h3>Billing address</h3>
        <AddressPicker
          customerAddresses={customerAddresses.data}
          onAddressChange={this.handleAddressChange}
        />
        <AddressForm
          object={object}
          changeFunction={change}
          settings={settings}
        />

        <div className="c7-checkout__content__buttons">
          <button type="submit" className="c7-button">
            Complete Reservation
          </button>
          <a onClick={this.handleBack}>Return to customer information</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values, props) => {
  let creditCard;
  const address = transformAddressData(values);
  address.customerAddressId = values.customerAddressId;
  if (requiresCreditCard(props.reservationCart)) {
    if (!values.customerCreditCardId || values.customerCreditCardId === '') {
      creditCard = {
        cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
        expiryMo: values.expiryMo && integerFormat(values.expiryMo),
        expiryYr: values.expiryYr && integerFormat(values.expiryYr),
        cvv2: values.cvv2,
        cardHolderName: values.cardHolderName
      };
    } else {
      creditCard = {
        customerCreditCardId: values.customerCreditCardId
      };
    }
  }
  return { address, creditCard };
};

const validate = (values, props) => {
  let errors = {};
  const { address } = transformData(values, props);
  address.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  address.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  address.birthYear =
    values.birthYear && convertStringToInteger(values.birthYear);
  errors = Object.assign(
    errors,
    validateAddressForLoggedInCustomer(address, props.settings)
  );
  if (requiresCreditCard(props.reservationCart)) {
    if (!values.customerCreditCardId || values.customerCreditCardId === '') {
      const { creditCard } = transformData(values, props);
      errors = Object.assign(errors, validateCreditCard(creditCard));
    }
  }
  return errors;
};

const mapStateToProps = (state) => {
  const reservationCart = state.reservationCart.data;
  let initialValues;
  let selectedCreditCardId;
  if (reservationCart) {
    const { billTo } = reservationCart;
    initialValues = initialFormValues(billTo);
    const { creditCard } = reservationCart;
    if (creditCard) {
      initialValues.customerCreditCardId = creditCard.customerCreditCardId;
      selectedCreditCardId = creditCard.customerCreditCardId;
    }
  }
  return {
    cart: state.cart,
    customer: state.customer,
    settings: state.setting,
    customerAddresses: state.customerAddress,
    customerCreditCards: state.customerCreditCard,
    initialValues,
    selectedCreditCardId
  };
};

Payment = reduxForm({
  form: 'paymentLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Payment);

export default withRouter(
  connect(mapStateToProps, {
    updateAndProcessReservationCart,
    listCustomerAddresses,
    listCustomerCreditCards
  })(Payment)
);
